module.exports = __webpack_public_path__ + "img/rosemount-3051s-multivariable-transmitter-1-rtd.4719a187.png";